import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=f00138f2&scoped=true"
import script from "./Dashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=f00138f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00138f2",
  null
  
)

export default component.exports